<template>
    <component
            
        :is="to ? NuxtLink : 'button'"
        :disabled="disabled || loading"
        :to="to"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";
import { type Component } from "vue";



withDefaults(
    defineProps<{
        as?: string | Component;        
        loading?: boolean;
        disabled?: boolean;
        to?: string;
    }>(),
    {
        as: "button",        
        loading: false,
        disabled: false,
    }
);

</script>
